import { ArrowDropDown, CircleTwoTone,DashboardOutlined } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  SvgIcon,
  Typography
} from "@mui/material";
import _ from "lodash";
import React, { Fragment, memo, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { openNav } from "../../../components/hooks/trigger";
import { useStyle } from "./style";

const Menu = ({ data, flag, setFlag }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyle();
  const [expand, setExpand] = useState(false);
  const [hover, setHover] = useState(null);
  const [active, setActive] = useState(null);

  const onHandle = (panel) => (event, isExpanded) => {
    setExpand(isExpanded ? panel : false);
  };
  const handleNavigate = (e, value) => {
   navigate(`${e}`);
    // console.log(e, value)
  };
  const handleActive = (id, value) => {
    setActive(id);
    setFlag(true);
    if (!flag) {
      dispatch(openNav());
    }
  };

  const SvgHtmlRenderer = ({ svgHtml }) => {
    return (
      <SvgIcon viewBox="0 0 24 24">
        <g dangerouslySetInnerHTML={{ __html: svgHtml }} />
      </SvgIcon>
    );
  }


  return (
    <Fragment>
      {!flag ? (
        <Accordion
          key="dashboard"
          disableGutters
          square
          className={classes.accordionRoot}
          expanded={expand === "Dashboard"}
          onChange={onHandle("Dashboard")}
          onMouseLeave={() => setHover(null)}
          onMouseEnter={() => setHover(null)}
        >
          <AccordionSummary
            className={
              active === null ? classes.active : classes.accordionSummary
            }
            onClick={() => handleActive(null, { menu_name: "Dashboard", submenus: [] })}
            expandIcon={null}
          >
            <Grid className="flex items-center" onClick={() => handleNavigate("/dashboard")}>
             {!flag ? <DashboardOutlined sx={{ fontSize: 24 }} /> : <DashboardOutlined sx={{ fontSize: 24 }} />} 
              {flag && 
              <Typography sx={{ fontSize: 18, marginLeft: 1 }} >
                Dashboard
              </Typography>
              }
            </Grid>
          </AccordionSummary>
        </Accordion>
      ) : 
      <Accordion
          key="dashboard"
          disableGutters
          square
          className={classes.accordionRoot}
          expanded={expand === "Dashboard"}
          onChange={onHandle("Dashboard")}
          onMouseLeave={() => setHover(null)}
          onMouseEnter={() => setHover(null)}
        >
          <AccordionSummary
            className={
              active === null ? classes.active : classes.accordionSummary
            }
            onClick={() => handleActive(null, { menu_name: "Dashboard", submenus: [] })}
            expandIcon={null}
          >
            <Grid className="flex items-center" onClick={() => handleNavigate("/dashboard")}>
             {!flag ? <DashboardOutlined sx={{ fontSize: 24 }} /> : <DashboardOutlined sx={{ fontSize: 24 }} />} 
              {flag && 
              <Typography sx={{ fontSize: 18, marginLeft: 1 }} >
                Dashboard
              </Typography>
              }
            </Grid>
          </AccordionSummary>
        </Accordion>
      }
      {_.map(data, (val, idx) => (
        <Accordion
          key={idx}
          disableGutters
          square
          className={classes.accordionRoot}
          expanded={expand === val.menu_name}
          onChange={onHandle(`${val.menu_name}`)}
          onMouseLeave={() => setHover(null)}
          onMouseEnter={() => setHover(idx)}
        >
          <AccordionSummary
            className={
              active === idx ? classes.active : hover === idx ? classes.hoverAcc : classes.accordionSummary
            }
            onClick={() => handleActive(idx, val)}
            expandIcon={
              flag && val.submenus ? <ArrowDropDown /> : null
            }
          >
            <Grid className="flex items-center " sx={{margin: flag ? 0 :'0 auto'}}>
              <SvgHtmlRenderer svgHtml={val.menu_icon} />
              {flag && <Typography sx={{fontSize:18,marginLeft:1}} >{val.menu_name}</Typography>}
            </Grid>
          </AccordionSummary>
          {flag && active === idx ? (
            <AccordionDetails>
              {_.map(val.submenus, (value, id) => (
                <Grid key={id}  className={
                  location?.pathname === value?.sub_menu_url ? classes.subMenuActiveGrid : classes.subMenuGrid 
                  } >
                  <CircleTwoTone sx={{ fontSize: 8, marginInline: 2 }} />
                  <Typography variant="body1"
                    onClick={() => handleNavigate(`${value.sub_menu_url}`, value)}
                   
                    sx={{ cursor: "pointer" }}
                  >
                    {value.sub_menu_name}
                  </Typography>
                </Grid>
              ))}
            </AccordionDetails>
          ) : null}
        </Accordion>
      ))}
    </Fragment>
  );
};

export default memo(Menu);
